module.exports = __webpack_public_path__ + "static/Regulamin_e_containers_eu_en-66369fcd3a3e992c8bcb59d4e2c7845f.pdf";